import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, createSlots as _createSlots } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_MeetingInfo = _resolveComponent("MeetingInfo")
  const _component_MdContent = _resolveComponent("MdContent")
  const _component_CollapseMenu = _resolveComponent("CollapseMenu")
  const _component_Segment = _resolveComponent("Segment")

  return (_openBlock(), _createBlock(_component_Segment, {
    class: "meeting-card",
    flat: "",
    "initial-open": $props.loading
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_MeetingInfo, {
        info: $options.info,
        loading: $props.loading,
        onSave: $options.save
      }, null, 8 /* PROPS */, ["info", "loading", "onSave"])
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ($options.markdown || !!$options.sections?.length)
      ? {
          name: "extra",
          fn: _withCtx(() => [
            ($options.markdown)
              ? (_openBlock(), _createBlock(_component_MdContent, {
                  key: 0,
                  class: "markdown",
                  markdown: $options.markdown
                }, null, 8 /* PROPS */, ["markdown"]))
              : (!!$options.sections?.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($options.sections, (section) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: section.title
                    }, [
                      (section.type === 'markdown')
                        ? (_openBlock(), _createBlock(_component_CollapseMenu, {
                            key: 0,
                            loading: !section.content,
                            class: "collapse-menu",
                            title: section.title
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MdContent, {
                                markdown: section.content
                              }, null, 8 /* PROPS */, ["markdown"])
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["loading", "title"]))
                        : _createCommentVNode("v-if", true)
                    ], 64 /* STABLE_FRAGMENT */))
                  }), 128 /* KEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["initial-open"]))
}